import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import shortid from 'shortid';

import Modal from 'components/common/modal-component';
import { ModalButton } from 'models/utils/common/modal-button-model';
import Statement from 'models/data/statement-model';

const RESTORE_DELETED_REVISION_ID_BLOCK = 'id-restore-deleted-revision-modal';
const RESTORE_DELETED_REVISION_BLOCK = 'restore-deleted-revision-modal';

const RestoreDeletedRevisionModal = ({ statement, onClose, onConfirm }) => {
  return (
    <Modal
      id={RESTORE_DELETED_REVISION_ID_BLOCK}
      className={RESTORE_DELETED_REVISION_BLOCK}
      title={
        'statement-list.restore-deleted-revision-modal.latest-revision-title'
      }
      onClose={onClose}
      primaryModalButton={
        new ModalButton({
          text: 'common.confirm',
          onClick: onConfirm,
        })
      }
      secondaryModalButton={
        new ModalButton({
          text: 'common.cancel',
          onClick: onClose,
        })
      }
    >
      <div className="modal__text">
        <FormattedMessage
          id={'statement-list.restore-deleted-revision-statement-modal'}
          values={{
            ul: (...chunks) => (
              <ul className={`${RESTORE_DELETED_REVISION_BLOCK}__ulTags`}>
                {chunks}
              </ul>
            ),
            li: (...chunks) => <li key={`${RESTORE_DELETED_REVISION_ID_BLOCK}-${shortid.generate()}`}>{chunks}</li>,
            b: (...chunks) => <strong key={`${RESTORE_DELETED_REVISION_ID_BLOCK}-${shortid.generate()}`}>{chunks}</strong>,
            br: <br id={`${RESTORE_DELETED_REVISION_ID_BLOCK}__brTag`} />,
            revisionNumber: statement?.revisionNumber,
            latestRevision: statement?.latestRevision,
          }}
        />
      </div>
    </Modal>
  );
};

RestoreDeletedRevisionModal.propTypes = {
  /** Statement model holding the revisions that can be deleted */
  statement: PropTypes.instanceOf(Statement).isRequired,
  /** function fired for cancel and close of modal */
  onClose: PropTypes.func.isRequired,
  /** primary function fired when deletion is confirmed */
  onConfirm: PropTypes.func.isRequired,
};

export default memo(RestoreDeletedRevisionModal);
